const NAMESPACE = 'ROOT_APP/';
export const SET_ACCESS_TOKEN = NAMESPACE + 'SET_ACCESS_TOKEN';
export const SHOW_ALERT = NAMESPACE + 'SHOW_ALERT';
export const HIDE_ALERT = NAMESPACE + 'HIDE_ALERT';
